import React, { useEffect, useState } from "react";
import { Phone, ArrowUp } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import WhatsAppLogo from "@/components/site/WhatsAppLogo";
import { FLOAT } from "@/constants/testIds";

export default function FloatingActions() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <a
        href="https://wa.me/919731852956?text=Hi%20Ramdev%20Steel%2C%20I%27d%20like%20to%20enquire%20about..."
        target="_blank"
        rel="noreferrer"
        data-testid={FLOAT.wa}
        aria-label="Chat on WhatsApp"
        className="wa-pulse fixed bottom-5 right-5 md:bottom-7 md:right-7 z-40 w-14 h-14 md:w-16 md:h-16 grid place-items-center rounded-full bg-white shadow-[0_12px_40px_-8px_rgba(37,211,102,0.6)] hover:scale-110 transition-transform"
      >
        <WhatsAppLogo size={36} />
      </a>
      <a
        href="tel:+919731852956"
        data-testid={FLOAT.call}
        aria-label="Call Ramdev Steel"
        className="fixed bottom-24 right-5 md:right-7 z-40 w-12 h-12 grid place-items-center rounded-full bg-[var(--steel)] text-white shadow-lg hover:scale-110 transition-transform"
      >
        <Phone size={18} />
      </a>
      <AnimatePresence>
        {visible && (
          <motion.button
            key="scrolltop"
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 12 }}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            data-testid={FLOAT.top}
            aria-label="Scroll to top"
            className="fixed bottom-5 left-5 md:bottom-7 md:left-7 z-40 w-11 h-11 grid place-items-center rounded-full border border-slate-200 bg-white text-slate-900 shadow-md hover:bg-slate-900 hover:text-white transition-colors"
          >
            <ArrowUp size={18} />
          </motion.button>
        )}
      </AnimatePresence>
    </>
  );
}
